<template>
  <div class="home">
    <Title class="title" />
    <div class="menu">
      <Play class="play" />
      <News class="news" />
    </div>
    <div class="my-footer">
      <div>
        Icons made by
        <a href="https://www.flaticon.com/authors/freepik" title="Freepik"
          >Freepik</a
        >
        from
        <a href="https://www.flaticon.com/" title="Flaticon"
          >www.flaticon.com</a
        >
      </div>
    </div>
  </div>
</template>

<script>
import Play from "@/components/Play.vue";
import News from "@/components/News.vue";
import Title from "@/components/Title.vue";
import axios from "axios";
import Cookies from "js-cookie";
const queryString = require("query-string");
// @ is an alias to /src

export default {
  name: "Home",
  components: {
    Play,
    News,
    Title
  },
  data: () => ({
    userInfo: {}
  }),
  methods: {
    async getUserInfo() {
      try {
        if (Cookies.get("token") === undefined) return;
        this.userInfo = await axios.get("/userInfo");
        // console.log(this.userInfo);
        this.$store.commit("kgamesConnect", this.userInfo.data);
      } catch (e) {
        this.refreshToken();
        // console.log(e);
      }
    },
    async refreshToken() {
      try {
        Cookies.set("token", await axios.get("/refreshToken"), {
          hostOnly: false,
          domain: window.location.hostname
            .split(".")
            .slice(1)
            .join("."),
          expires: Cookies.get("isSession") === "false" ? 2100 : undefined
        });
        this.getUserInfo();
      } catch (e) {
        // console.log(e);
      }
    }
  },
  mounted() {
    window.onpopstate = function() {
      history.go(-1);
    };
    this.getUserInfo();
    let { error } = queryString.parse(location.search);
    let roomId = queryString.parse(location.search).join;
    if (error) {
      this.$buefy.toast.open({
        duration: 3000,
        message: error,
        position: "is-top",
        type: "is-danger"
      });
      this.$router.push("/");
    }
    if (roomId && localStorage["clientId"]) {
      this.$colyseus.client
        .reconnect(roomId, localStorage["clientId"])
        .then(room => {
          // console.log("joined successfully", room);
          this.stateChange(room);
        })
        .catch(e => {
          console.error("join error", e);
          this.$router.push("/");
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.home {
  height: 100%;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: 0.8fr 1.6fr 0.6fr;
  gap: 1px 1px;
  grid-template-areas: ". title title ." ". menu menu ." ". my-footer my-footer .";
  justify-items: center;
  align-items: center;
  @media only screen and (max-width: 800px) {
    grid-template-columns: 0.05fr 1fr 0.05fr;
    grid-template-rows: 0.1fr 1fr 0.1fr;
    grid-template-areas: ". title ." ". menu ." ". my-footer .";
    justify-items: center;
    align-items: center;
  }
}

.title {
  grid-area: title;
}

.menu {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(2, 1fr);
  gap: 1px 10px;
  grid-template-areas: "play news" "play news";
  grid-area: menu;
  @media only screen and (max-width: 800px) {
    grid-template-areas: "play play" "news news";
    gap: 10px 10px;
  }
}

.play {
  grid-area: play;
}

.news {
  grid-area: news;
}

.my-footer {
  grid-area: my-footer;
}
</style>
